import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const COOKIE_CONSENT_KEY = "cookie-consent";

type ConsentValue = "accepted" | "refused";

export function useCookieConsent() {
  const [consent, setConsent] = useState<ConsentValue | null>(() => {
    return localStorage.getItem(COOKIE_CONSENT_KEY) as ConsentValue | null;
  });

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setConsent("accepted");
  };

  const refuse = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "refused");
    setConsent("refused");
  };

  return { consent, accept, refuse };
}

export function CookieConsent() {
  const { consent, accept, refuse } = useCookieConsent();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Small delay to avoid flash on page load
    if (consent === null) {
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, [consent]);

  if (consent !== null || !visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background p-lg safe-area-bottom">
      <div className="mx-auto flex max-w-2xl flex-col gap-md sm:flex-row sm:items-center sm:justify-between">
        <p className="text-body-md text-muted-foreground">
          Nous utilisons des cookies d'analyse pour améliorer le service.{" "}
          <Link to="/legal" className="underline">En savoir plus</Link>
        </p>
        <div className="flex shrink-0 gap-sm">
          <Button variant="outline" size="sm" onClick={refuse}>
            Refuser
          </Button>
          <Button size="sm" onClick={accept}>
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
}
